import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const context = '.page-template-template-mixology section:not(.hero)';

if (document.querySelector(context)) {

    let mm = gsap.matchMedia();

    let textArray = gsap.utils.toArray([`${context} h2`, `${context} h3`, `${context} h5`, `${context} p:not(.little-bold)`]);
    let imgArray = gsap.utils.toArray([`${context} .width-animation`, `${context} .width-animation-reverse`, `${context} .height-animation`, `${context} .height-animation-reverse`]);

    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (animContext) => {
        let { isMobile, isDesktop } = animContext.conditions;
        let offset = isMobile ? 100 : 200;

        gsap.from( `${context}.posts .post`, {
            scrollTrigger: {
                trigger: `${context}.posts .post`,
                start: `top bottom-=${offset}`,
                end: 'bottom top',
                once: true,
            },
            opacity: 0,
            duration: .5,
            stagger: .3,
            y: 50,
        });

        imgArray.forEach(img => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: img,
                    start: `center bottom`,
                    end: 'bottom top',
                    once: true,
                    onUpdate: self => {
                        self.trigger.style.setProperty('--animWidth', "100%");
                    },
                }
            });
        });
    
        textArray.forEach(text => {
            let textTl = gsap.timeline({
                scrollTrigger: {
                    trigger: text,
                    start: `top bottom-=${offset}`,
                    end: 'bottom top',
                    once: true,
                }
            });
            textTl.from(text, {opacity: 0, duration: 1, y: 20});
        });
        
    });

}
